module.exports = __webpack_public_path__ + "static/media/top-no-older-than-me-light-icon.2069e510.svg";